export const buildText = "Version 1.5 | 24-Aug-2024";
